import React, { useEffect, useState, useRef } from "react";

const CustomAutoComplete = ({
  placeholder = "",
  value,
  setValue,
  onSearch,
  onSelect,
  externalUserSelected = false, // 👈 Novo parâmetro opcional
  readOnly = false,
  disabled = false
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [userSelected, setUserSelected] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (userSelected || externalUserSelected) {
        return;
      }
      if (value && value.length >= 2) {
        onSearch(value)
          .then((results) => {
            setSuggestions(results);
            // Não mostrar automaticamente se foi carregado externamente
            if (!externalUserSelected) {
            setShowSuggestions(true);
            }
            setHighlightedIndex(-1);
          })
          .catch(() => {
            setSuggestions([]);
            setShowSuggestions(false);
          });
      } else {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    }, 300);

    return () => clearTimeout(delay);
  }, [value, onSearch, userSelected, externalUserSelected]);

  // 👇 Novo effect para fechar sugestões se usuário externo marcou seleção
  useEffect(() => {
    if (externalUserSelected) {
      setShowSuggestions(false);
      setUserSelected(true); // simula que foi escolhido manualmente
    } else {
      // Quando externalUserSelected muda para false, permitir busca novamente
      setUserSelected(false);
    }
  }, [externalUserSelected]);

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (suggestions.length > 0) {
        setShowSuggestions(true);
      }
      setHighlightedIndex((prev) => Math.min(prev + 1, suggestions.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      if (suggestions.length > 0) {
        setShowSuggestions(true);
      }
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0 && suggestions[highlightedIndex]) {
        const selected = suggestions[highlightedIndex];
        setUserSelected(true);
        setValue(selected.name);
        onSelect(selected);
        setSuggestions([]);
        setShowSuggestions(false);
      }
    } else if (e.key === "Escape") {
      setShowSuggestions(false);
    } else {
      // Qualquer outra tecla digitada, mostrar sugestões se houver
      if (suggestions.length > 0) {
        setShowSuggestions(true);
      }
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setUserSelected(true);
    setValue(suggestion.name);
    onSelect(suggestion);
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const handleBlur = () => {
    setTimeout(() => setShowSuggestions(false), 100);
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        ref={inputRef}
        className="form-control form-control-sm"
        onChange={(e) => {
          if (!disabled && !readOnly) {
            setUserSelected(false);
            setValue(e.target.value);
            // Quando o usuário digita, resetar externalUserSelected para permitir busca
            if (externalUserSelected) {
              // Isso será tratado pelo componente pai através do setValue customizado
            }
          }
        }}
        onKeyDown={handleKeyDown}
        onFocus={async () => {
          if (!disabled && !readOnly) {
            // Se o usuário clicar no campo e houver valor, buscar sugestões
            if (value && value.length >= 2 && !userSelected && !externalUserSelected) {
              try {
                const results = await onSearch(value);
                setSuggestions(results);
                if (results.length > 0) {
                  setShowSuggestions(true);
                }
              } catch {
                setSuggestions([]);
                setShowSuggestions(false);
              }
            } else if (suggestions.length > 0 && !userSelected && !externalUserSelected) {
              setShowSuggestions(true);
            }
          }
        }}
        onBlur={handleBlur}
        style={{
          WebkitAppearance: "none",
        }}
        readOnly={readOnly || disabled}
        disabled={disabled}
      />
      {showSuggestions && suggestions.length > 0 && (
        <ul
          className="list-group position-absolute w-100 zindex-tooltip"
          style={{
            maxHeight: "200px",
            overflowY: "auto",
            zIndex: 99999, // Adicionado aqui
            background: "white", // Garante que não herda fundo transparente
          }}
        >
          {suggestions.map((s, index) => (
            <li
              key={s.id}
              className={`list-group-item list-group-item-action ${index === highlightedIndex ? "active" : ""
                }`}
              onMouseDown={() => handleSuggestionClick(s)}
            >
              {s.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomAutoComplete;
